import ApiService from "../../services/ApiService"
import { isLoading, setError, setSuccessMessage } from "./uxAction"

export function createFaq({ question, answer }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokePost(process.env.REACT_APP_API_URL + `/admin/api/secured/faq`, {
            question, 
            answer
        })

        if (resp.status >= 400) {
            dispatch(setError(resp.data.errors))
        }

        dispatch(isLoading(false))

        if (callback)
            callback(resp.data.data)
    }
}

export function fetchAllQuestions({ query, page = 0, limit = 20 }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))
        
        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/faq?query=${query}&page=${page}&limit=${limit}`)

        dispatch(isLoading(false))

        if (resp.status === 200) {
            const { data } = resp.data
            await dispatch({
                type: 'FETCH_FAQ',
                payload: data
            })


        if (callback)
            callback({
                filteredData: data.filteredData,
                totalFiltered: data.filteredData?.length,
                total: data.total
            })
        }
    }
}

export function bulkDeleteQuestion({ questionIds = [] }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokeDelete(process.env.REACT_APP_API_URL + `/admin/api/secured/faq`, {
                questionIds
            })

            dispatch(isLoading(false))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "Item(s) deleted"
                }))
            }

            if (callback)
                callback()

        } catch (e) { }
    }
}

export function updateFaq({ faqId, question, answer }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokePatch(process.env.REACT_APP_API_URL + `/admin/api/secured/faq/${faqId}`, {
                question,
                answer
            })

            dispatch(isLoading(false))

            if (resp.status >= 400)
                dispatch(setError(resp.data.errors))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "updated successfully"
                }))
            }

            if (callback)
                callback()


        } catch (e) { }
    }
}